import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ContentCopy from "@mui/icons-material/ContentCopy";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { formatRenderCellDateValues } from ".";
import {
  EMPTY_DATE_CELL,
  formatProgramDateRangeLabel,
  formatWallClockMonthDayYear,
  formatWallClockTime,
  getProgramEndTime,
  getProgramStartTime,
} from "./wallClockTime";
import FilterIcon from "../assets/icon_components/FilterIcon";
import StatusIndicator from "../shared/StatusIndicator/StatusIndicator";
import {
  itemTitle,
  itemTitlePlural,
  MenteesType,
} from "../utils/constant";
import MuiTooltipWrapper from "../component/Tooltip/Tooltip";
import { AccountCircle, HowToRegTwoTone } from "@mui/icons-material";

const formatProgramTimeRange = (program) => {
  const startTime = formatWallClockTime(getProgramStartTime(program), {
    compact: true,
  });
  const endTime = formatWallClockTime(getProgramEndTime(program), {
    compact: true,
  });

  if (startTime && endTime) {
    return `${startTime} – ${endTime}`;
  }
  return startTime || endTime || "";
};

const formatDurationLabel = (duration) => {
  const days = Number(duration);
  if (!Number.isFinite(days) || days <= 0) return "";
  return `${days} ${days === 1 ? "day" : "days"}`;
};

const isRecurringProgramFlag = (value) =>
  value === true || value === "true" || value === 1 || value === "1";

export const isCopiedProgram = (program) => {
  if (!program) return false;
  if (program.reopen_program) return true;
  return !program.start_date && !program.end_date;
};

export const AssignedToMeBadge = ({ className = "" }) => (
  <MuiTooltipWrapper title="This event is assigned to you">
    <span
      className={`flex items-end shrink-0 ${className}`}
    >
      <HowToRegTwoTone
        fontSize="small"
        className="text-green-800"
      />
    </span>
  </MuiTooltipWrapper>
);

export const CopiedEventBadge = () => (
  <span
    className="inline-flex items-center gap-1 shrink-0"
    style={{
      color: "#64748B",
      border: "0.5px dashed #CBD5E1",
      borderRadius: "2px",
      padding: "2px 6px",
      lineHeight: "1.4",
      fontSize: "12px",
      fontWeight: "600",
    }}
  >
    <ContentCopy className="h-4 w-4" />
    Copied
  </span>
);

const TimeNotSetLabel = () => (
  <span className="flex items-center gap-1 text-sm font-semibold text-[#B45309] mt-0.5 whitespace-nowrap">
    <WarningAmberRoundedIcon sx={{ fontSize: 16, color: "#B45309" }} />
    Time not set
  </span>
);

export const renderProgramDateTimeCell = (program) => {
  if (!program) {
    return <div>{EMPTY_DATE_CELL}</div>;
  }

  const isRecurring = isRecurringProgramFlag(program.recurring_program);

  if (isRecurring) {
    const dateRange = formatProgramDateRangeLabel(
      program.start_date,
      program.end_date
    );
    const durationLabel = formatDurationLabel(program.duration);

    return (
      <div className="flex h-full min-w-0 flex-col justify-center leading-tight">
        {dateRange ? (
          <span className="font-semibold text-sm text-gray-900 whitespace-nowrap">
            {dateRange}
          </span>
        ) : (
          <TimeNotSetLabel />
        )}
        {dateRange && durationLabel ? (
          <span className="text-xs text-font-primary-main text-semibold mt-0.5 whitespace-nowrap">
            {durationLabel}
          </span>
        ) : null}
      </div>
    );
  }

  const dateLabel = formatWallClockMonthDayYear(program.start_date);
  const timeRange = formatProgramTimeRange(program);

  return (
    <div className="flex h-full min-w-0 flex-col justify-center leading-tight">
      {dateLabel ? (
        <span className="font-semibold text-sm text-gray-900 whitespace-nowrap">
          {dateLabel}
        </span>
      ) : null}
      {timeRange ? (
        <span className="flex items-center gap-1 text-xs text-font-primary-main text-semibold mt-0.5 whitespace-nowrap">
          <AccessTimeOutlinedIcon sx={{ fontSize: 12 }} />
          {timeRange}
        </span>
      ) : (
        <TimeNotSetLabel />
      )}
    </div>
  );
};

export const renderLocationCell = (locationData) => {
  if (!locationData) {
    return (
      <div className="flex h-full gap-2 items-center">
        <span>...</span>
      </div>
    );
  }

  const { city, state_code } = locationData;

  return (
    <div className="flex h-full gap-2 items-center">
      <span>
        {city && state_code ? (
          <span>
            {city}&#44;{state_code}
          </span>
        ) : city || state_code ? (
          <span>
            {city && `${city}`}
            {state_code && `&#44;${state_code}`}
          </span>
        ) : (
          <span>...</span>
        )}
      </span>
    </div>
  );
};
export const myMenteeColumns = (clickHandler) => [
  {
    field: "first_name",
    headerName: "First Name",
    flex: 1,
    minWidth: 100,
    id: 0,
    renderCell: (params) => {
      return (
        <>
          <div
            className="cursor-pointer flex justify-start items-center"
            onClick={() => clickHandler(params?.row)}
          >
            <span className="text-font-primary-main underline truncate max-w-32">
              {params?.row?.first_name}
            </span>
          </div>
        </>
      );
    },
  },
  // {
  //   field: "middle_name",
  //   headerName: "Middle Name",
  //   flex: 1,
  //   id: 0,
  // },
  {
    field: "last_name",
    headerName: "Last Name",
    flex: 1,
    minWidth: 100,
    id: 0,
  },
  // {
  //   field: "Professional_Bio",
  //   headerName: "Professional",
  //   flex: 1,
  //   id: 1,
  // },
  {
    field: "phone_number",
    headerName: "Contact",
    flex: 1,
    minWidth: 100,
    id: 2,
  },
  {
    field: "email",
    headerName: "Email",
    flex: 1,
    minWidth: 100,
    id: 1,
  },
  {
    field: "location",
    headerName: "Location",
    flex: 1,
    minWidth: 100,
    id: 2,
    sortable: false,
    // align: "center",
    // headerAlign: "center",
    renderCell: (params) => renderLocationCell(params?.row?.location_data),
  },
  {
    field: "attended_program_count",
    headerName: `Attended ${itemTitlePlural}`,
    flex: 1,
    minWidth: 180,
    id: 2,
    // headerAlign: "center",
    // align: "center",
  },
  {
    field: "last_attend_program",
    headerName: `Last Attended ${itemTitle}`,
    flex: 1,
    minWidth: 180,
    id: 1,
  },
];

export const myReqMenteeColumns = [
  {
    field: "name",
    headerName: "Name",
    flex: 1,
    minWidth: 100,
    id: 1,
  },
  {
    field: "profession",
    headerName: "professional",
    flex: 1,
    minWidth: 100,
    id: 1,
  },
  {
    field: "contact",
    headerName: "Contact",
    flex: 1,
    minWidth: 100,
    id: 1,
  },
  {
    field: "email",
    headerName: "Email",
    flex: 1,
    minWidth: 100,
    id: 1,
  },
  {
    field: "location",
    headerName: "Location",
    flex: 1,
    minWidth: 100,
    id: 2,
  },
  {
    field: "created_at",
    headerName: "Requested Date",
    flex: 1,
    minWidth: 100,
    id: 1,
    renderCell: (params) => {
      return formatRenderCellDateValues(params?.row?.created_at);
    },
  },
  {
    field: "last_updated_date",
    headerName: "Last Updated Date",
    flex: 1,
    minWidth: 100,
    id: 1,
    /*************  ✨ Windsurf Command ⭐  *************/
    /**
     * Renders the cell content for the "Last Updated Date" column.
     *
     * @param {Object} params - The parameters provided to the render function.
     * @param {Object} params.row - The data object for the current row.
    
    /*******  5815cf9e-6dbd-4201-9bed-5d6aa02cd71b  *******/
    renderCell: (params) => {
      return formatRenderCellDateValues(params?.row?.last_updated_date);
    },
  },
];

export const discussionColumns = [
  {
    field: "program_name",
    headerName: `${itemTitle} Name`,
    flex: 1,
    id: 1,
  },
  {
    field: "description",
    headerName: "Description",
    flex: 1,
    id: 2,
  },
  {
    field: "date",
    headerName: "Date",
    flex: 1,
    id: 3,
    renderCell: (params) => {
      return formatRenderCellDateValues(params.row.date);
    },
  },
  {
    field: "task",
    headerName: "Assignments",
    flex: 1,
    id: 4,
  },
  {
    field: "users",
    headerName: "Users",
    flex: 1,
    id: 5,
  },
  {
    field: "comments",
    headerName: "Comments",
    flex: 1,
    id: 6,
  },
  {
    field: "last_update_by",
    headerName: "Last update by",
    flex: 1,
    id: 7,
  },
];

export const memberRequestColumns = [
  {
    field: "name",
    headerName: "Name",
    flex: 1,
    id: 1,
  },
  {
    field: "email",
    headerName: "Email",
    flex: 1,
    id: 2,
  },
  {
    field: "address",
    headerName: "Location",
    flex: 1,
    id: 3,
  },
];

export const certificateColumns = [
  {
    field: "category_name",
    headerName: "Category",
    flex: 1,
    id: 0,
    for: ["mentor", "mentee", "admin"],
    status: [],
  },
  {
    field: "program_name",
    headerName: `${itemTitle} Name`,
    flex: 1,
    id: 1,
    for: ["mentor", "mentee", "admin"],
  },
  // {
  //     field: 'program_location',
  //     headerName: 'Location',
  //     flex: 1,
  //     id: 1,
  //     for: ['mentee']
  // },
  {
    field: "start_date",
    headerName: "Start Date",
    flex: 1,
    id: 1,
    for: ["mentee"],
    renderCell: (params) => {
      return formatRenderCellDateValues(
        params?.row?.program_start_date_and_time
      );
    },
  },
  {
    field: "end_date",
    headerName: "End Date",
    flex: 1,
    id: 1,
    for: ["mentee"],
    renderCell: (params) => {
      return formatRenderCellDateValues(params?.row?.program_end_date_and_time);
    },
  },
  {
    field: "approved_date",
    headerName: "Approved Date",
    flex: 1,
    id: 1,
    for: ["mentee"],
    renderCell: (params) => {
      return formatRenderCellDateValues(params?.row?.approved_date);
    },
  },
  {
    field: "approved_by_full_name",
    headerName: "Approved by",
    flex: 1,
    id: 1,
    for: ["mentee"],
  },

  {
    field: "participates_count",
    headerName: MenteesType,
    flex: 1,
    id: 2,
    for: ["mentor", "admin"],
  },
  {
    field: "pass_participates_count",
    headerName: "Pass",
    flex: 1,
    id: 1,
    for: ["mentor"],
  },
  {
    field: "fail_participates_count",
    headerName: "No Pass",
    flex: 1,
    id: 1,
    for: ["mentor"],
  },
  {
    field: "created_at",
    headerName: "Request Date",
    flex: 1,
    id: 1,
    for: ["mentor", "admin"],
    renderCell: (params) => {
      // return <div>{dateFormat(params.row.created_at)}</div>

      return formatRenderCellDateValues(params?.row?.created_at);
    },
  },
  {
    field: "created_by_full_name",
    headerName: "Requested by",
    flex: 1,
    id: 1,
    for: ["admin"],
  },
  {
    field: "updated_at",
    headerName: "Last updated Date",
    flex: 1,
    id: 1,
    for: ["mentor", "admin"],
    renderCell: (params) => {
      return formatRenderCellDateValues(params?.row?.updated_at);
    },
  },
  {
    field: "updated_by_full_name",
    headerName: "Last updated by",
    flex: 1,
    id: 1,
    for: ["mentor", "admin"],
  },
];
export const certificateMenberColumns = [
  {
    field: "mentee_name",
    headerName: "Mentee",
    flex: 1,
    id: 1,
  },
  {
    field: "program_name",
    headerName: `${itemTitle} Name`,
    flex: 1,
    id: 1,
  },
];

export const topProgramListColumns = [
  {
    field: "program_name",
    headerName: `${itemTitle} Name`,
    flex: 1,
    sortable: false,
    id: 0,
    renderCell: (params) => {
      return <>{params?.row?.program_name ?? "..."}</>;
    },
  },
  {
    field: "category_name",
    headerName: "Category",
    flex: 1,
    sortable: false,
    id: 1,
    renderCell: (params) => {
      return <>{params?.row?.category?.[0] ?? "..."}</>;
    },
  },
  {
    field: "type",
    headerName: `${itemTitle} Type`,
    flex: 1,
    sortable: false,
    id: 1,
    renderCell: (params) => {
      return (
        <>
          {!params?.row?.type
            ? "..."
            : params?.row?.type === "training_program"
            ? "Volunteer Training Program"
            : "Field Action Program"}
        </>
      );
    },
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   flex: 1,
  //   id: 5,
  //   renderCell: (params) => {
  //     //     return <>
  //     //     <div className='cursor-pointer flex items-center justify-center h-full relative'>

  //     //         <span className='w-[100px] flex justify-center h-[30px] px-4'
  //     //             style={{
  //     //                 background: programStatusColor[params?.row?.status]?.bgColor, lineHeight: '30px',
  //     //                 borderRadius: '3px', width: '110px', height: '34px',  fontSize: '12px', color: programStatusColor?.[params?.row?.status]?.color
  //     //             }}>
  //     //             {programStatusText?.[params?.row?.status]}
  //     //         </span>
  //     //     </div>
  //     //  </>
  //     const { status } = params.row;
  //     return (
  //       <div className="cursor-pointer flex items-center  h-full relative">
  //         <StatusIndicator status={status}> </StatusIndicator>
  //       </div>
  //     );
  //   },
  // },
];

export const topMentorListcolumns = [
  {
    field: "first_name",
    headerName: "First Name",
    flex: 1,
    id: 0,
    renderCell: (params) => {
      return <>{params?.row?.first_name ?? "..."}</>;
    },
  },
  // {
  //   field: "middle_name",
  //   headerName: "Middle Name",
  //   flex: 1,
  //   id: 0,
  //   renderCell: (params) => {
  //     return <>{params?.row?.middle_name ? params?.row?.middle_name : "..."}</>;
  //   },
  // },
  {
    field: "last_name",
    headerName: "Last Name",
    flex: 1,
    id: 0,
    renderCell: (params) => {
      return <>{params?.row?.last_name ?? "..."}</>;
    },
  },
];

export const programListColumns = (
  handleStatusFilterClick = () => false,
  activeTab = "",
  hideFilterStatus = false,
  typeFromParams = ""
) => {
  return [
    {
      field: "date_and_time",
      headerName: "Date & Time",
      flex: 3,
      minWidth: 200,
      id: 4,
      sortable: false,
      renderCell: (params) => renderProgramDateTimeCell(params?.row),
    },
    // {
    //   field: "frequency",
    //   headerName: "Frequency",
    //   flex: 1,
    //   id: 6,
    //   renderCell: (params) => {
    //     return (
    //       <div>
    //         {
    //           CourseLevelOptions.find(
    //             (course) => course.key === params.row.reminder_type
    //           )?.value
    //         }
    //       </div>
    //     );
    //   },
    // },
    // {
    //     field: 'to_request',
    //     headerName: 'Start date & End Date',
    //     flex: 1,
    //     id: 4,
    //     renderCell: (params) => {
    //       return <div>{formatRenderCellDateValues(params?.row?.start_date)} & {formatRenderCellDateValues(params?.row?.end_date)}</div>
    //   }
    // },
    // {
    //     field: 'duration',
    //     headerName: 'Durations',
    //     flex: 1,
    //     id: 5,
    //     renderCell: (params) => {
    //       return <div className="pl-4">{params.row.duration} {params?.row?.duration>1?"Days":"Day"}</div>
    //     }
    // },
    {
      field: "status",
      flex: 1.5,
      minWidth: 180,
      headerName: "Status",
      // flex: 1,
      renderHeader: (params) => (
        <div className="flex items-center gap-1">
          <span className="font-semibold">Status</span>
          {(!activeTab ||
            activeTab === "yettojoin" ||
            activeTab === "planned") &&
            !hideFilterStatus && (
              <FilterIcon
               className="w-4 h-4 pt-1"
                onClick={(e) => {
                  e.stopPropagation();
                  handleStatusFilterClick(e);
                }}
              />
            )}
        </div>
      ),

      renderCell: (params) => {
        return (
          <div className="flex items-center  h-full w-full">
            <StatusIndicator status={params.row.status}></StatusIndicator>
          </div>
        );
      },
    },
  ];
};
